var EmailSignupForm = (function($) {
    function onSubmit($form, onSuccess) {
        $form.on('submit', function(e) {
            e.preventDefault();
            e.stopPropagation();

            register($form, onSuccess);
        });
    };

    function register($form, onSuccess) {
        $.ajax({
            type: $form.attr('method'),
            url: $form.attr('action').replace('/post?', '/post-json?').concat('&c=?'),
            data: $form.serialize(),
            dataType: 'jsonp',
            error : function(err) {
                alert('An unexpected error occured. Please try again.');
            },
            success : function(data) {
                if (data.result == 'success') {
                   $form.html('<p>We have sent you a confirmation email.</p>');

                   if (typeof onSuccess === 'function')
                        onSuccess();
                } else {
                    alert('An error occured. Please check your email and try again.');
                }
            }
        });
    };

    return {
        onSubmit: onSubmit
    };
})(jQuery);

// Popup
var Popup = (function($, EmailSignupForm) {
    var $popupForm = $('#shop-sage-form'),
        $popupContainer = $('.subscription-popup-wrapper'),
        $popup = $('.popup');

    function setCookie() {
        document.cookie = "Popup=newsletter-signed-up; expires=Thu, 18 Dec 2019 12:00:00 UTC";
    };

    function show() {
        $popupContainer.show();

        // Dont show Popup right away.
        setTimeout(function(){
            $popupContainer.addClass('show-me');
        }, 1000);
    };

    function hide() {
        $popupContainer.hide();
        $popupContainer.removeClass('show-me');
    }

    function setupEvents() {
        $popup.find('.exit').on('click', hide);
    }

    function cookieExists() {
        return (document.cookie.indexOf('newsletter-signed-up') === -1) ? false : true;
    };

    function open() {
        if (!cookieExists()) {
            show();
            EmailSignupForm.onSubmit($popupForm, setCookie);
            setupEvents();
        }
    };

    return {
        open: open
    };

})(jQuery, EmailSignupForm);

$(document).ready(function() {
    'use strict';

    // Equalize
    function equalHeights() {
        var $row = $('.equal');

        if ($row.length > 0) {
            $row.each(function() {
                var $sections = $(this).children(),
                    largestHeight = 0;

                $sections.height('auto');

                $sections.each(function() {
                    var h = $(this).height();
                    if (largestHeight < h) largestHeight = h;
                });

                $sections.height(largestHeight);
            });
        }
    }

    // Run
    $(window).on({
        load: function() {
            equalHeights();

            // Register Footer Form
            EmailSignupForm.onSubmit($('#mc-embedded-subscribe-form'));
        },
        resize: function() {
            equalHeights();
        }
    });
});
